import * as S from "./styles.ts";
import { Button, Radio } from "@template/components";
import { useTypedDispatch, useTypedSelector } from "@/redux/helpers/hooks.ts";
import { INumberQueryOptions } from "@/redux/slices/numbers/types.ts";
import { changeNumberOption } from "@/redux/slices/numbers";

const Footer = ({
                  onClickSearch = undefined,
                }: {
  onClickSearch?: () => void;
}) => {
  const noAutoSearch = onClickSearch !== undefined;
  const dispatch = useTypedDispatch();

  const standardLoading = useTypedSelector(
    (state) => state.numbers.numbers.standard.loading,
  );
  const premiumLoading = useTypedSelector(
    (state) => state.numbers.numbers.premium.loading,
  );
  const loading = standardLoading || premiumLoading;
  const options = useTypedSelector((state) => state.numbers.options);

  const toggleOption = (key: keyof INumberQueryOptions, value: any) =>
    dispatch(changeNumberOption({ key, value }));

  const showAdvanced = options.showAdvanced;
  const setShowAdvanced = (val: boolean) => toggleOption("showAdvanced", val);

  return (
    <S.FooterContainer>
      <Radio
        selected={showAdvanced ? "advanced" : null}
        onChange={(val) => setShowAdvanced(val === "advanced")}
        options={[
          {
            key: "advanced",
            label: "Advanced Search",
          },
        ]}
      />
      <Button
        size="md"
        loading={noAutoSearch ? false : loading}
        onClick={onClickSearch}
      >
        Search Numbers
      </Button>
    </S.FooterContainer>
  );
};

export default Footer;
